dmx.Component('data-detail', {

    initialData: function() {
        return {
            data: {}
        };
    },

    tag: 'div',

    attributes: {
        data: {
            type: Array,
            default: []
        },

        key: {
            type: String
        },

        value: {
            type: [String, Number]
        }
    },

    methods: {
        select: function(value) {
            this.props.value = value;
            this.select(value);
        }
    },

    render: function(node) {
        this.items = [];
        dmx.BaseComponent.prototype.render.call(this, node);
        this.setData(this.props.data);
        this.select(this.props.value);
    },

    update: function(props) {
        if (JSON.stringify(props.data) !== JSON.stringify(this.props.data)) {
            this.setData(this.props.data);
            this.select(this.props.value);
        }

        if (props.value !== this.props.value) {
            this.select(this.props.value);
        }
    },

    setData: function(data) {
        this.items = [];

        if (data && typeof data == 'object') {
            if (Array.isArray(data)) {
                this.items = data.map(function(item) {
                    return (typeof item === 'object') ? item : { $value: item };
                });
            } else {
                for (var key in data) {
                    this.items.push({ $key: key, $value: data[key] });
                }
            }
        }
    },

    select: function(value) {
        var index = this.items.findIndex(function(item) {
            return item[this.props.key] === this.props.value;
        }, this);

        this.set('data', this.items[index] || null);
    }

});
